<template>
  <div class="codes-form">
    <div class="main">
      <el-card class="box-card margin-b-20">
        <p class="encabezado"><strong>Captura los códigos</strong> de los boletos que entregarás a tu cliente.</p>
        <el-form
          ref="codesForm"
          :rules="rules"
          :model="model"
          class="form-container"
          @submit.native.prevent="onSubmit"
        >
          <el-form-item
            ref="inputTyres"
            prop="tyres"
            label="Llantas Michelin® vendidas"
          >
            <el-input-number
              v-model="model.tyres"
              :min="1"
              :max="10"
            />
            <div class="input-helper">El número de llantas debe de coincidir con el número de llantas reportadas en la factura.</div>
          </el-form-item>
          <div class="codes-container">
            <el-form-item
              v-for="(code, $index) in model.tyres"
              :key="$index"
              :prop="'codes'"
              :label="'Código del Boleto ' + ($index + 1) "
            >
              <el-select
                v-model="model.codes[$index]"
                :loading="isLoading"
                :remote-method="onCodeSearch"
                remote
                filterable
                no-data-text="El código no existe"
                placeholder="Introduzca el código">
                <el-option
                  v-for="item in codes"
                  :key="item.id"
                  :label="item.code"
                  :value="item.code"
                >
                  {{ item.code }}
                </el-option>
              </el-select>

            </el-form-item>
          </div>

          <el-row :gutter="10">
            <el-col :span="12">
              <router-link :to="{name:'invoice'}">
                <el-button>Atrás</el-button>
              </router-link>
            </el-col>
            <el-col :span="12">
              <el-button
                :disabled="submitting"
                type="primary"
                native-type="submit">Siguiente
              </el-button>
            </el-col>
          </el-row>
        </el-form>
      </el-card>
    </div>
  </div>
</template>

<script>
import CodesModel from '@/models/codes.model'

/**
*
* CodesForm Component
*
* @author Fernando Torres
* @copyright 2019, Marciano Studio S.C.
*/
export default {
  name: 'CodesForm',
  data () {
    return {
      isLoading: false,
      codes: [],
      submitting: false,
      model: CodesModel.model(),
      rules: CodesModel.rules()
    }
  },
  mounted () {
    this.model = Object.assign({}, this.$store.getters['app/order'])
  },
  methods: {
    onCodeSearch (code, callback) {
      this.isLoading = true
      this.$store.dispatch('codes/query', {
        'filters[where][code][contains]': code,
        'filters[where][status][eq]': 'undelivered'
      }).then(response => {
        console.log(response.data)
        this.codes = response.data.items
        this.isLoading = false
      })
    },
    handleSelect () {

    },
    onSubmit () {
      this.submitting = true
      this.$refs.codesForm.validate((valid) => {
        if (valid) {
          this.$store.dispatch('app/order', this.model).then(() => {
            this.$router.push({name: 'client'})
          })
        } else {
          this.submitting = false
        }
      })
    }
  }
}
</script>

<style lang='scss' scoped>
  .codes-form {
    .codes-container{
        max-height: 50vh;
        overflow: auto;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/codes-form.vue